import {EnvironmentProvider} from 'providers/EnvironmentProvider'
import {OrderDetailsProvider} from 'providers/OrderDetailsProvider'
import {OrderProvider} from 'providers/OrderProvider'
import {Queries} from 'providers/Queries'
import {ResultProvider} from 'providers/ResultProvider'
import {Theme} from 'providers/Theme'
import {Toaster} from 'providers/Toaster'
import {Basic} from 'types'
import {View} from './View'

export const Confirming = (input: Basic.Input) => {
  return (
    <Toaster>
      <EnvironmentProvider {...input}>
        <Theme>
          <OrderDetailsProvider>
            <Queries>
              <OrderProvider>
                <ResultProvider>
                  <View />
                </ResultProvider>
              </OrderProvider>
            </Queries>
          </OrderDetailsProvider>
        </Theme>
      </EnvironmentProvider>
    </Toaster>
  )
}
